
/* FLoating buttons + Sticky bar Start */
function handleScreenSize() {
    var bundleClass = document.querySelector('.azo_byob .product_box');
        if (bundleClass) {
            if (window.matchMedia('(max-width: 767px)').matches) {
                bundleClass.classList.add('col_mob_view');
            } else {
                bundleClass.classList.remove('col_mob_view');
            }
        }
             /*if (button) {
                if (window.matchMedia('(max-width: 991px)').matches) {
                        button.style.display = 'none';
                } else {
                        button.style.display = '';
                }
            }*/
    }
    setTimeout(function() {
      handleScreenSize();
      setInterval(handleScreenSize, 100);
  }, 500);


document.addEventListener('scroll', function () {
    var productTemplate = document.querySelector('#product-template');
    var footer = document.querySelector('#footer');
    var stickyProductBar = document.getElementById('sticky-product-bar');
    if (!productTemplate || !footer || !stickyProductBar) {
        return;
    }
    var productTemplateTop = productTemplate.getBoundingClientRect().top + window.scrollY;
    var footerBottom = footer.getBoundingClientRect().top + window.scrollY;
    var scrollPosition = window.scrollY;
    var viewportHeight = window.innerHeight;
    if (scrollPosition > productTemplateTop + productTemplate.offsetHeight && scrollPosition + viewportHeight < footerBottom) {
        stickyProductBar.classList.add('fixed-sticky');
    } else {
        stickyProductBar.classList.remove('fixed-sticky');
    }
});

document.addEventListener('DOMContentLoaded', function () {
    let styleElement;
    let observer;

    function updateStyles() {
        const bundleheight = document.querySelector('.azo_byob .selected_products.active .col_mob_view .box_header')?.offsetHeight || 0;
        const cookieConsentWrapper = document.querySelector('.cookieconsent-wrapper');
        const barHeight = document.querySelector('.fixed-sticky')?.offsetHeight || 0;

        if (cookieConsentWrapper) {
            const parentDisplay = window.getComputedStyle(cookieConsentWrapper.parentElement).display;
            if (parentDisplay !== 'none') {
                const cookieHeight = cookieConsentWrapper.offsetHeight;
                const newOffsetTop = cookieHeight + 55 + barHeight;
                const newCHATTop = cookieHeight + 15 + barHeight;
                const newCHATWrapper = cookieHeight + 10 + barHeight;
                const newKlaviyoBtn = cookieHeight - 1 + barHeight;

                if (!styleElement) {
                    styleElement = document.createElement('style');
                    document.head.appendChild(styleElement);
                }
                styleElement.innerHTML = `
                  button.needsclick:not(.klaviyo-close-form):not(.klaviyo_footer_wrapper button.needsclick) ,
                  button.needsclick:not(.klaviyo-close-form):not(.klaviyo_footer_wrapper button.needsclick) {
                    bottom: ${newKlaviyoBtn}px !important;
                  }
                  .ascb_btn {
                    bottom: ${newOffsetTop}px !important;
                  }
                  access-widget-ui {
                    --offset-top: ${newOffsetTop}px !important;
                  }
                  .fixed-sticky {
                     bottom: ${cookieHeight}px !important;
                  }
                  .chatbot-container-btn {
                    bottom: ${newCHATTop}px !important;
                  }
                  .AstuteBotMessengerContainer,
                  .AstuteBotLauncher {
                    bottom: ${newCHATWrapper}px !important;
                  }
                `;
            } else {
                if (styleElement) {
                    styleElement.remove();
                    styleElement = null;
                }
            }
        } else if (barHeight) {
            const newOffsetTop = 55 + barHeight;
            const newCHATTop = 15 + barHeight;
            const newCHATWrapper = 10 + barHeight;
            const newKlaviyoBtn = -1 + barHeight;

            if (!styleElement) {
                styleElement = document.createElement('style');
                document.head.appendChild(styleElement);
            }
            styleElement.innerHTML = `
          button.needsclick:not(.klaviyo-close-form):not(.klaviyo_footer_wrapper button.needsclick) ,
          button.needsclick:not(.klaviyo-close-form):not(.klaviyo_footer_wrapper button.needsclick) {
            bottom: ${newKlaviyoBtn}px !important;
          }
          .ascb_btn {
            bottom: ${newOffsetTop}px !important;
          }
          access-widget-ui {
            --offset-top: ${newOffsetTop}px !important;
          }

          .chatbot-container-btn {
            bottom: ${newCHATTop}px !important;
          }
          .AstuteBotMessengerContainer,
          .AstuteBotLauncher {
            bottom: ${newCHATWrapper}px !important;
          }
        `;
        } else if ( bundleheight ) {
        const bundlenewOffsetTop = 55 + bundleheight;
        const bundlenewCHATTop = 15 + bundleheight;
        const bundlenewCHATWrapper = 10 + bundleheight;
        const bundlenewKlaviyoBtn = -1 + bundleheight;

        if (!styleElement) {
            styleElement = document.createElement('style');
            document.head.appendChild(styleElement);
        }
        styleElement.innerHTML = `
       
           access-widget-ui {
            --offset-top: ${bundlenewOffsetTop}px !important;
          }
          .ascb_btn {
            bottom: ${bundlenewOffsetTop}px !important;
          }
          .fixed-sticky {
            bottom: ${barHeight}px !important;
          }
          .chatbot-container-btn ,
          .chatbot-container {
            bottom: ${bundlenewCHATTop}px !important;
          }
          .AstuteBotMessengerContainer,
          .AstuteBotLauncher {
            bottom: ${bundlenewCHATWrapper}px !important;
          }
        `;
    } else {
            if (styleElement) {
                styleElement.remove();
                styleElement = null;
            }
        }
    }
    function setupObserver() {
        const cookieConsentWrapper = document.querySelector('.cookieconsent-wrapper');
        if (cookieConsentWrapper) {
            if (observer) {
                observer.disconnect();
            }
            observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
                        updateStyles();
                    }
                });
            });
            observer.observe(cookieConsentWrapper.parentElement, {
                attributes: true,
                attributeFilter: ['style', 'class'],
            });
        }
    }
    setTimeout(function () {
        updateStyles();
        setupObserver();
        setInterval(updateStyles, 100);
    }, 2000);
});

/* FLoating buttons + Sticky bar End */